












import { Component as NodeComponent } from 'vue'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { MemberMap } from '@/types/newPersion'
import DoalogSlot from '@/components/dialog/doalogSlot.vue'
import PersionDialog from '@/views/newPension/productCard/persionDialog/index.vue'
import FamilyDialog from '@/views/newPension/productCard/familyDialog/index.vue'
interface RefTs {submit: Function}
@Component({
  components: {
    DoalogSlot
  }
})
export default class SettignDialog extends Vue {
    @Prop() settingDialogShow!: boolean
    page: NodeComponent = PersionDialog
    ref = 'persion'
    familyInfo: MemberMap | null = null
    rightHide = true
    dialogProp: {} = {
      leftText: '取消',
      title: '选择被保险人',

    }

    propClick: {} = {
      'on-close': this.handleClose
    }

    private handleClick (type: string, tableRow?: MemberMap) {
      switch (type) {
        case 'family':
          this.handleFamily(tableRow)
          break
        case 'persion':
        default:
          this.handlePersion(tableRow)

          break
      }
      this.ref = type
    }

    handlePersion (tableRow?: MemberMap) {
      this.rightHide = true
      if (tableRow) {
        this.$emit('on-setting-dialog', true, tableRow)
      } else {
        this.dialogProp = {
          leftText: '取消',
          title: '选择被保险人',
        }
        this.propClick = {
          'on-close': this.handleClose
        }
        this.page = PersionDialog
      }
    }

    handleFamily (tableRow?: MemberMap) {
      this.rightHide = false
      if (tableRow) {
        this.familyInfo = tableRow
        this.dialogProp = {
          leftText: '取消',
          title: '编辑家庭成员',
          rightText: '确定',
        }
      } else {
        this.familyInfo = null
        this.dialogProp = {
          leftText: '取消',
          title: '添加家庭成员',
          rightText: '确定',
        }
      }
      this.page = FamilyDialog
      this.propClick = {
        'on-close': this.handleClose,
        'on-confirm': this.handleConfirm
      }
    }

    private async handleConfirm () {
      this.rightHide = true
      const status = await (this.$refs[this.ref] as unknown as RefTs).submit()
      if (status) {
        this.handleClick('persion')
      }
    }

    private handleClose () {
      switch (this.ref) {
        case 'family':
          this.rightHide = true
          this.ref = 'persion'
          this.familyInfo = null
          this.page = PersionDialog
          break
        case 'persion':
        default:
          this.$emit('on-setting-dialog', false)
          break
      }
    }
}
